import React, { FC, useEffect, useState } from "react";
import { DailyStats } from "./dailyStats";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { Stack, Typography } from "@mui/material";

export type CompletionTimeProps = {
  stats: DailyStats;
  hard?: boolean;
};

export const CompletionTimeChart: FC<CompletionTimeProps> = ({ stats, hard }) => {
  const [data, setData] = useState<any[]>([]);
  useEffect(() => {
    const statsArray = Object.entries(stats);
    const data = [0,1,2,3,4,5]
      .map((i) => ({
        name: i === 0 ? "<1 Minute" : (i === 5 ? ">5 Minutes" : `${i.toString()} Minutes`),
        count: statsArray.filter(
          ([key, value]) =>
            value[hard ? "hard" : "easy"] &&
            (i === 5
              ? value[hard ? "hard" : "easy"].completionTimeInSeconds >= 300
              : (value[hard ? "hard" : "easy"].completionTimeInSeconds > (i*60)) && value[hard ? "hard" : "easy"].completionTimeInSeconds < ((i+1)*60 )
            )
        ).length,
      }));
    setData(data);
  }, [stats, hard]);
  return (
    <Stack alignItems={"center"} height={'100%'}>
      <Typography fontWeight={'bold'}>Completion Time</Typography>
      <ResponsiveContainer width={"100%"} height={"100%"}>
        <BarChart data={data}>
          <Bar dataKey={"count"} name={'Count'} fill={'#108164'} />
          <XAxis dataKey={"name"} />
          <Tooltip />
        </BarChart>
      </ResponsiveContainer>
    </Stack>
  );
};
